/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_mobile_analytics_app_id": "f7a86f2c41a24b459570c2fd409f3aa1",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "f7a86f2c41a24b459570c2fd409f3aa1",
            "region": "us-east-1"
        }
    },
    "aws_cloud_logic_custom": [
        {
            "name": "InceptionDatabaseApi",
            "endpoint": "https://a9z1pks69a.execute-api.us-east-1.amazonaws.com/newdemo",
            "region": "us-east-1"
        },
        {
            "name": "chameleonDBAPI",
            "endpoint": "https://ebfkbsg79d.execute-api.us-east-1.amazonaws.com/newdemo",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:dddfa670-b62f-40e7-a8ab-7a3d344e70d8",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_cjeuTqASw",
    "aws_user_pools_web_client_id": "67i6h1bq0n8hesiajl5cnnkp2a",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": "8",
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_content_delivery_bucket": "chameleon-hostingbucket-prod-newdemo",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d2j9evmg8cuifx.cloudfront.net",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "accounts-newdemo",
            "region": "us-east-1"
        },
        {
            "tableName": "alerts-newdemo",
            "region": "us-east-1"
        },
        {
            "tableName": "alertsHistory-newdemo",
            "region": "us-east-1"
        },
        {
            "tableName": "loginQuestion-newdemo",
            "region": "us-east-1"
        },
        {
            "tableName": "personaInformation-newdemo",
            "region": "us-east-1"
        },
        {
            "tableName": "resources-newdemo",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "chameleon-newf0af0d209f7640b3a512713369d9168b-newdemo",
    "aws_user_files_s3_bucket_region": "us-east-1"
};
export default awsmobile;
//# sourceMappingURL=aws-exports.js.map